module.exports = __webpack_public_path__ + "static/media/golf-crisis-web.6ae39a6b.jpg";